import { convertToCurrencyValue } from '@/utils/format-currency';
import React, { useEffect, useState } from 'react';
import style from './style.module.css';

interface MonetaryInputProps {
  titleInputSelect: string;
  onChange?: (value: string) => void;
  placeholder: string;
  name?: string;
  value?: string;
  maxLength?: number;
  disabled?: boolean;
}

// Max length given currency symbols
const MAX_LENGTH = 18;

const MonetaryInput = ({
  titleInputSelect,
  onChange,
  name,
  placeholder,
  value: initialValue,
  maxLength = MAX_LENGTH,
  disabled = false,
}: MonetaryInputProps) => {
  const [value, setValue] = useState(initialValue);
  const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = ev.target.value.replace(/[^\d]/g, '');

    // Só atualiza se houver números ou se o campo estiver vazio
    if (numericValue || ev.target.value === '') {
      const currency = convertToCurrencyValue(numericValue);
      setValue(currency);
      if (onChange) onChange(currency);
    }
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <label className={style.containerMonetaryInput}>
      <div className={style.titleMonetaryInput}>
        <span>{titleInputSelect}</span>
      </div>

      <div className={style.contentMonetaryInputContainer}>
        <input
          type="text"
          className={style.contentMonetaryInput}
          name={name}
          onChange={handleChange}
          placeholder={placeholder}
          value={value}
          maxLength={maxLength}
          disabled={disabled}
        />
      </div>
    </label>
  );
};

export default MonetaryInput;
